export default {
	EVENTNUMBEROFDAYS: 'eventnumberofdays',
	ISOILRATIOBYGENDER: 'isoilratiobygender',
	DAILYOILRATIOS: 'dailyoilratios',
	DAILYOILRATIOSMEN: 'dailyoilratiosmen',
	DAILYOILRATIOSWOMEN: 'dailyoilratioswomen',
	OILRATIO: 'oilratio',
	OILRATIO_FIRST: 'oilratiofirst',
	OILRATIO_SECOND: 'oilratiosecond',
	OILRATIO_THIRD: 'oilratiothird',
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/LaneConditions/fields.js